import { render, staticRenderFns } from "./chatbot.vue?vue&type=template&id=32a45217&scoped=true&"
import script from "./chatbot.vue?vue&type=script&lang=js&"
export * from "./chatbot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a45217",
  null
  
)

export default component.exports